import { createResponse } from "../lib/functions";
import {
  CodeBook,
  Settings,
} from "../lib/golObjectTypes/SearchFlightResponse/ExtendedResponse2";
import { BrandServiceName } from "../types/brands";
import golApiCall from "./golApiCall";
import { Flights } from "./types/flightSearch";

interface IResponse {
  success?: boolean;
  codebook?: CodeBook & {
    BrandServiceNames: { BrandServiceName: BrandServiceName[] };
  };
  data?: {
    FlightOffers: { FlightOffer: Flights };
  };
  meta?: {
    PassiveSessionId: string;
    CodeBook: CodeBook & {
      BrandServiceNames: { BrandServiceName: BrandServiceName[] };
    };
    Settings: Settings;
  };
  errorCode?: number | string;
  errorMsg?: string;
  errorDetail?:
    | string
    | {
        message: string;
        type: string;
      };
}

type ResponseErrorType = "NoAvailableSeatsError" | "Generic";

export const checkErrorType = (data: IResponse): ResponseErrorType | null => {
  if (data.success) {
    return null;
  }
  const noAvailableSeatsErrorCode = "3092";
  return data?.errorCode === noAvailableSeatsErrorCode
    ? "NoAvailableSeatsError"
    : "Generic";
};

const createRequest = (
  refs: string[],
  keepBookingClass: boolean | undefined
) => {
  return {
    GolApi: {
      RequestDetail: {
        BrandsDetailsRequest_1: {
          ...(keepBookingClass === false && {
            KeepBookingClass: keepBookingClass.toString(),
          }),
          SearchedReferences: {
            Reference: refs.map((oRef) => ({ $t: oRef })),
          },
        },
      },
    },
  };
};

const brandsDetailsRequest = async (
  refs: string[],
  keepBookingClass: boolean | undefined,
  alternativeCurrency?: string
): Promise<IResponse> => {
  const response = await golApiCall(createRequest(refs, keepBookingClass), {
    ...(alternativeCurrency ? { alternativeCurrency } : {}),
  });

  const returnedResponse = createResponse(response);

  return returnedResponse;
};

export default brandsDetailsRequest;
